import { useRef } from 'react';
import { useClickAway, useKeyPressEvent, useLockBodyScroll } from 'react-use';

import { Portal } from 'components/Portal';

import * as S from './Modal.styles';
import { StyledBoxProps } from './Modal.styles';

type ModalProps = {
  children: React.ReactNode;
  onClose?: () => void;
  asSecondaryStructure?: boolean;
  hasModalChild?: boolean;
} & StyledBoxProps;

export function Modal(props: ModalProps): React.ReactElement {
  const {
    children,
    onClose,
    asFullModal,
    asSecondaryStructure = false,
    hasModalChild = false,
  } = props;

  const ref = useRef(null);

  if (!asFullModal && !hasModalChild) {
    useClickAway(ref, onClose!);
  }

  useKeyPressEvent('Escape', onClose);

  useLockBodyScroll(true);

  if (asSecondaryStructure) {
    return (
      <Portal>
        <S.Container onClick={(e) => e.stopPropagation()}>
          <S.ContainerInner>
            {onClose ? <S.CloseButton iconLeft="FiX" onClick={onClose} /> : undefined}

            <S.Box ref={ref}>{children}</S.Box>
          </S.ContainerInner>
        </S.Container>
      </Portal>
    );
  }

  return (
    <Portal>
      <S.Container onClick={(e) => e.stopPropagation()}>
        <S.Box ref={ref} asFullModal={asFullModal}>
          <S.BoxInner>
            {onClose ? <S.CloseButton iconLeft="FiX" onClick={onClose} /> : undefined}

            {children}
          </S.BoxInner>
        </S.Box>
      </S.Container>
    </Portal>
  );
}
